import type Fuse from 'fuse.js';
import { ReactNode } from 'react';

import { highlight } from './fuzzySearchHelper';

export const boldMatchCharacters = (value: string, matches: readonly Fuse.FuseResultMatch[] = []): ReactNode => {
  if (matches.length) {
    return highlight(value, matches[0].indices);
  }
  return value;
};
